<template>
  <v-menu offset-y>
    <template #activator="{ on }">
      <v-btn
        small
        outline
        round
        :color="color"
        :ripple="!readonly"
        v-on="!readonly ? on : undefined"
      >
        {{ text }}
        <v-icon v-if="!readonly" small>arrow_drop_down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-tile v-for="item in items" :key="item.value" @click="select(item.value)">
        <v-list-tile-title :class="`${item.color}--text`">{{ item.text }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { SENTIMENT_LIST } from '@/constants/sentiment'

export default {
  props: {
    value: {
      type: String,
      default: 'neutral',
      validator: (value) => ['positive', 'negative', 'neutral'].includes(value)
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: (() => {
        const color = {
          neutral: '#3E8DF3',
          positive: '#1E9753',
          nagative: '#F2B344'
        }
        return SENTIMENT_LIST.map((item) => ({
          ...item,
          color: color[item.value.toLowerCase()]
        }))
      })()
    }
  },
  computed: {
    color() {
      const item = this.items.find((item) => this.value && item.value === this.value.toLowerCase())
      return item ? item.color : ''
    },
    text() {
      const item = this.items.find((item) => this.value && item.value === this.value.toLowerCase())
      return item ? item.text : ''
    }
  },
  methods: {
    select(value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/ReplyComment/SentimentMenu.vue